import React from 'react';
import { useTranslation } from 'react-i18next';

import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Typography } from '@mui/material';

import { IStudentProgramModel } from '@common/models/StudentPrograms/StudentProgram';
import { IStudentProgramLessonModel } from '@common/models/StudentPrograms/StudentProgramLesson';

import ProgramLessonDeadline from '../DeadlineIcon';
import ProgramLessonLockStatus from '../LockIcon';
import LessonStatusCompleted from './Completed';
import { StyledLessonStatus } from './styled';

interface PropsType {
	lesson: IStudentProgramLessonModel;
	lessonsKey: keyof IStudentProgramModel['lessons'];
}

function LessonStatus({ lesson, lessonsKey }: PropsType) {
	const { t } = useTranslation();

	const { deadline } = lesson;

	if (lesson.status === 2 || lessonsKey === 'completed') {
		return <LessonStatusCompleted lesson={lesson} />;
	}

	if (lesson.status === 3) {
		return (
			<StyledLessonStatus
				color="error"
				label={
					<>
						<Typography variant="subtitle3">{t('program.rejected')}</Typography>
						<ClearOutlinedIcon />
					</>
				}
			/>
		);
	}

	if (lesson.status === 1 && lessonsKey === 'all_lessons') {
		return <StyledLessonStatus label={t('program.checking')} color="warning" />;
	}

	if (lesson.status === 0) {
		if (lesson.is_lock) {
			return <ProgramLessonLockStatus startDate={lesson.start} />;
		}
	}

	if (lesson.status === 0 || lesson.status === 3) {
		if (deadline) {
			return <ProgramLessonDeadline deadline={deadline} />;
		}
	}

	return null;
}

export default LessonStatus;
